// extracted by mini-css-extract-plugin
module.exports = {"btn-primary":"_modal_btn-primary__yW80I","modal":"_modal_modal__Yx08A"};